import lazyLoadWithRetry from 'utils/lazyLoadWithRetry';

export const SalaryExplainerWrapper = lazyLoadWithRetry(
  () => import('components/AiSalaryExplainer/SalaryExplainer'),
);

export const Integrations = lazyLoadWithRetry(() =>
  import('components/Integrations').then((module) => ({ default: module.Integrations })),
);


export const AssetGallery =
  process.env.NODE_ENV === 'production'
    ? null
    : lazyLoadWithRetry(() => import('components/AssetGallery'));
